<template>
    <div class="settlement">
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>采购订单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="销售订单编号" label-width="100px">
                        <el-input v-model="searchForm.saleOrderNo" placeholder="销售订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" label-width="70px">
                        <el-input v-model="searchForm.orderNo" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="采购方" label-width="70px"  >
                        <el-select filterable  collapse-tags clearable size="mini" mul v-model="searchForm.purchaser" placeholder="采购方"  style="width: 200px">
                            <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商" label-width="70px">
                        <el-select filterable  collapse-tags clearable size="mini" mul v-model="searchForm.supplier" placeholder="供应商"  style="width: 200px">
                            <el-option
                                v-for="item in suppliers"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch()" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition" align="right">

                    <RightToolBar :showSearch="showSearch" @reDrawTable="reDrawTable"
                                  :columns="dropCol" ></RightToolBar>

                </div>
                <div ref="tablePosition"></div>
                <el-table
                    size="mini"
                    stripe
                    :key = "updateTable"
                    ref="dataTable"
                    :data="tableData"
                    row-key="id"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column width="auto" :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[0].isShow"
                                     :key="dropCol[0].id"
                                     :prop="dropCol[0].prop"
                                     :label="dropCol[0].label"></el-table-column>
                    <el-table-column width="auto" :min-width="200"
                                     class-name="drag"
                                     v-if="dropCol[1].isShow"
                                     :key="dropCol[1].id"
                                     :prop="dropCol[1].prop"
                                     :label="dropCol[1].label"></el-table-column>
                    <el-table-column width="auto" :min-width="200"
                                     class-name="drag"
                                     v-if="dropCol[2].isShow"
                                     :key="dropCol[2].id"
                                     :prop="dropCol[2].prop"
                                     :label="dropCol[2].label"></el-table-column>
                    <el-table-column width="auto"  :min-width="120"
                                     class-name="drag"
                                     v-if="dropCol[3].isShow"
                                     :key="dropCol[3].id"
                                     :prop="dropCol[3].prop"
                                     :label="dropCol[3].label"></el-table-column>
                    <el-table-column width="auto" :min-width="120"
                                     class-name="drag"
                                     v-if="dropCol[4].isShow"
                                     :key="dropCol[4].id"
                                     :prop="dropCol[4].prop"
                                     :label="dropCol[4].label"
                    ></el-table-column>
                    <el-table-column
                            v-if="dropCol[5].isShow"
                            :key="dropCol[5].id"
                            :prop="dropCol[5].prop"
                            :label="dropCol[5].label"
                            width="auto" min-width="120" align="center">

                    </el-table-column>
<!--                    <el-table-column width="auto" prop="price" label="含税总价(元)" :min-width="120"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="saleOrder" label="采购结算单号" :min-width="160"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="order" label="订单号" :min-width="160"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="supplierOrder" label="供应商订单号" :min-width="160"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="purchaser" label="采购方" :min-width="200"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="supplier" label="供应商" :min-width="200"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="untaxedPrice" label="未税总价(元)" :min-width="120"></el-table-column>-->
<!--                    <el-table-column width="auto" prop="price" label="含税总价(元)" :min-width="120"></el-table-column>-->
<!--                     <el-table-column fixed="right" prop="status" label="状态" width="100" align="center">-->
<!--                         <template slot-scope="scope">-->
<!--                            <el-tag size="mini">{{ scope.row.statusShow }}</el-tag><i class="el-icon-edit" style="color:#409eff;margin-left:8px;cursor: pointer;" @click="handleShowEditStatusDialog(scope.row)"></i>-->
<!--                         </template>-->
<!--                     </el-table-column>-->
                    <el-table-column width="160" align="right" fixed="right" header-align="center"
                        v-if="dropCol[6].isShow"
                        :key="dropCol[6].id"
                        :prop="dropCol[6].prop"
                        :label="dropCol[6].label">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToReviewDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px" v-if="total > 0">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="上传供货单" :visible.sync="visibleUploadDeliver" width="800px" :close-on-click-modal="false">
            <el-upload
                :action="`/api/admin/purchaseOrder/uploadDeliver/${uploadDeliverPOId}`"
                list-type="picture-card"
                :file-list="deliverImages"
                :on-success="onUploadSuccess"
                :auto-upload="true">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                    <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                        <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                        >
                        <i class="el-icon-zoom-in"></i>
                        </span>
                    </span>
                    </div>
            </el-upload>
        </el-dialog>
        <el-dialog title="预览" :visible.sync="dialogPreviewVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="修改状态" :visible.sync="dialogEditStatusVisible" width="400px">
            <el-form ref="editStatusForm" :model="editStatusForm" :rules="rules" label-width="90px" size="mini">
                <el-form-item label="采购订单号" prop="order">
                    <el-input v-model="editStatusForm.order" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editStatusForm.status" placeholder="请选择订单状态" style="width: 100%" clearable>
                        <el-option
                            v-for="item in optionStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditStatusVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleEditStatus" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="交票信息" :visible.sync="dialogInvoice" width="400px">
            <el-form ref="invoiceForm" :model="invoiceForm" :rules="rules2" label-width="90px" size="mini">
                <el-form-item label="采购订单号" prop="order">
                    <el-input v-model="invoiceForm.order" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="含税总额" prop="price">
                    <el-input v-model="invoiceForm.price" placeholder="请输入发票号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="发票号" prop="invoice">
                    <el-input v-model="invoiceForm.invoice" placeholder="请输入发票号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogInvoice = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleInvoice" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
import { KeepAliveTableMixins } from '../../mixin/KeepAliveTable.js';
const HEIGHT_OFFSET = 118;
import RightToolBar from "../../components/RightToolBar";
import Sortable from "sortablejs";
export default {
    components:{RightToolBar},
    mixins: [KeepAliveTableMixins],

    data() {
        return {
            dialogInvoice:false,
            invoiceForm: {
                ids: [],
                id: "",
                order: "",
                invoice: "",
            },
            showSearch:false,
            updateTable:"pTable",
            dropCol:[
                {id:"0",label:'订单号',prop:'order',isShow:true},
                {id:"1",label:'采购方',prop:'purchaser',isShow:true},
            {id:"2",label:'供应商',prop:'supplier',isShow:true},
                {id:"3",label:'未税总价(元)',prop:'untaxedPrice',isShow:true},
                {id:"4",label:'含税总价(元)',prop:'price',isShow:true},
                {id:"5",label:'错误信息',prop:'message',isShow:true},
                {id:"6",label:'操作',prop:'op',isShow:true}],
            pageLoadng: undefined,
            tableConfig: {
                height: 0,
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            companys:[],
            suppliers: [],
            money: 0,
            invoiceList:[],
            addressList:[],
            reviewVisible:false,
            searchForm: {
                companyId: "",
                timeDate: "",
                status: "",
            },
            searchFormExport: {},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },
            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//
            },
            selectData:[],//选中的数据

            visibleUploadDeliver: false,
            uploadDeliverPOId: "",
            dialogImageUrl: '',
            dialogPreviewVisible: false,
            deliverImages: [],

            dialogEditStatusVisible: false,
            editStatusForm: {
                id: "",
                order: "",
                status: 0,
            },
            optionStatus: [{
                value: 10,
                label: '已下单',
            },{
                value: 11,
                label: '已接单',
            },{
                value: 20,
                label: '已发货',
            // },{
            //     value: 21,
            //     label: '部分发货',
            },{
                value: 30,
                label: '妥投',
            // },{
            //     value: 31,
            //     label: '部分妥投',
            },{
                value: 40,
                label: '拒收',
            // },{
            //     value: 41,
            //     label: '部分拒收',
            },],
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
            rules2: {

                invoice: [
                    { required: true, message: '请输入发票号', trigger: 'blur' }
                ],


            },
        }
    },
    methods: {
        //重绘表格
        reDrawTable() {
            this.updateTable = "pTable"+Math.random();
            this.$nextTick(()=>{
                this.columnDrop();
            });

        },
        //列拖拽
        columnDrop(){
            try{
                //const wrapperTr = this.$refs.purchaseTable.$el.querySelector('.el-table__header-wrapper tr');
                const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
                let oldLabel;
                let newLabel;
                let oldIndex;
                let newIndex;
                let count=0;
                const that=this;
                this.sortable = Sortable.create(wrapperTr, {
                    animation: 180,
                    delay: 30,
                    draggable:".drag",
                    onEnd: evt => {

                        oldLabel=this.$refs.dataTable.columns[evt.oldIndex].property;
                        newLabel=this.$refs.dataTable.columns[evt.newIndex].property;
                        for (let i=0;i<that.dropCol.length;i++){
                            if (that.dropCol[i].prop!=undefined&&that.dropCol[i].prop==newLabel)
                                newIndex=i;

                        }

                        for (let j=0;j<that.dropCol.length;j++){
                            if (that.dropCol[j].prop!=undefined&&that.dropCol[j].prop==oldLabel)
                                oldIndex=j;
                        }

                        const oldItem = this.dropCol[oldIndex];
                        this.dropCol.splice(oldIndex, 1);
                        this.dropCol.splice(newIndex, 0, oldItem);

                        this.dropCol.forEach((item)=>{
                            if(item.prop==newLabel||item.prop==oldLabel){
                                item.id=new Date().getTime() + (++count)+"";
                                //console.log(JSON.stringify(this.dropCol));// eslint-disable-line
                            }
                        })



                    },
                });
            }catch (e) {
                console.log(e);// eslint-disable-line
            }
        },
        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        onSearch() {

            const that = this;
            const cond = {...this.searchForm};
            Object.keys(cond).forEach(key => {
                if(cond[key] instanceof Array) {
                    if(cond[key].length === 0) {
                        delete cond[key];
                    } else if(!cond[key]) {
                        delete cond[key];
                    }
                } else if(!cond[key]) {
                    delete cond[key];
                }
            })
            this.loading = true;
            this.$axios.post("/admin/errorOrder/search",{
                cond,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        judgeSelect(row){
            return row.isInvoice == false // 返回true该行可选，返回false则不可选
        },
        selectChanged(invoiceId) {
            if(invoiceId != null && invoiceId != ""){

                let one = null;
                for(let i=0;i<this.invoiceList.length;i++){
                    let item = this.invoiceList[i];
                    if(item.id == invoiceId){
                        one = item;
                    }
                }
                if(one != null) {
                    this.reviewForm = one;
                    this.reviewForm.invoiceId = invoiceId;
                }

            }else{
                this.reviewForm = {};
                this.reviewForm.invoiceId = "";
            }

        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            this.$router.push({name: "errorOrderDetail", params:{title:'异常订单详情',id: row.id}});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/customerCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        loadSuppliers(){
            let _this = this
            this.$axios.post("/admin/company/supplierCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.suppliers = resp.data;
                }

            });

        },
        andleSelectionChange(val) {
            this.selectData = val;
        },
        handleToDeliver(row) {
            this.viewDeliverVisible = true;
            this.$router.push({name: "saleOrderDeliver", params: {from: "order", orderId: row.id,title:'签收单',hide:true}});
        },
        exportProcurementContract(id){
            this.pageLoadng = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            downloadByPost({
                axios: this.$axios,
                url: '/admin/product/order/exportPurchaseContract/' + id,
                success: response => {
                    convertRes2Blob(response);
                },
                faild: () => {
                    this.$message({
                        type: 'error',
                        message: '合同导出失败',
                        duration: 2000
                    });
                },
                complete: () => {
                    this.pageLoadng.close();
                    this.pageLoadng = undefined;
                }
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogPreviewVisible = true;
        },
        onUploadSuccess(resp, file) {
            const { data } = resp;
            if(data === '上传失败') {
                return;
            }
            this.deliverImages = [...this.deliverImages, {name: file.name, url: data}];

        },
        handleUploadDeliver(row) {
            const that = this;
            this.deliverImages = [];
            this.uploadDeliverPOId = row.id;
            this.$axios
            .get("/admin/purchaseOrder/getDeliverImages/" + row.id)
            .then((resp) => {
                const { data } = resp.data;
                that.deliverImages = data.map(it => ({name: it.filename, url: it.path}));
            });
            this.visibleUploadDeliver = true;
        },
        handleShowEditStatusDialog(row) {
            this.editStatusForm.id = row.id;
            this.editStatusForm.order = row.order;
            this.editStatusForm.status = row.status;
            this.dialogEditStatusVisible = true;
        },
        handleEditStatus() {
            const that = this;
            this.$axios
            .post("/admin/purchaseOrder/updateStatus", this.editStatusForm)
            .then((response) => {
                let resp = response.data;
                if(resp.header.status !== 0) {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                    return;
                }
                that.onSearch();
                this.dialogEditStatusVisible = false;
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        handleShowInvoiceDialog(row) {
            console.log("do");// eslint-disable-line
            this.invoiceForm.ids = [];
            this.invoiceForm.id = row.id;
            this.invoiceForm.order = row.order;
            this.invoiceForm.price = row.price;
            this.invoiceForm.invoice = row.invoice;
            this.dialogInvoice = true;
        },
        handleShowSelectedInvoiceDialog() {
            if(!this.selectData || this.selectData.length === 0) {
                this.$notify.error({
                    title: '错误',
                    message: '请先选择订单'
                });
                return;
            }
            const hasInvoice = this.selectData.filter(it => it['invoice']).map(it => it['order']);
            if(hasInvoice.length > 0) {
                this.$notify.error({
                    title: '错误',
                    message: '已有发票的订单不能批量交票'
                });
                return;
            }
            this.invoiceForm.ids = this.selectData.map(it => it['id']);
            this.invoiceForm.id = '';
            this.invoiceForm.order = this.selectData.map(it => it['order']).join(',');
            this.invoiceForm.price = this.selectData.map(it => it['price']).reduce((prev, cur) => {
                return prev + cur;
            });
            this.invoiceForm.invoice = '';
            this.dialogInvoice = true;
        },
        handleInvoice() {
            const that = this;
            const ids = this.invoiceForm.ids && this.invoiceForm.ids.length > 0 ? this.invoiceForm.ids : [this.invoiceForm.id];
            this.$refs.invoiceForm.validate(valid => {
                    if (valid) {
                        this.$axios
                            .post("/admin/purchaseOrder/updateInvoice", {ids, invoice: this.invoiceForm.invoice})
                            .then((response) => {
                                let resp = response.data;
                                if(resp.header.status !== 0) {
                                    that.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                    return;
                                }
                                that.onSearch();
                                that.dialogInvoice = false;
                            });
                    }

                    })

        },
        more(command){
            if(command && command.length > 6 && command.substr(0,6)==="export") {
                if (this.selectData.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择要导出的订单',
                        duration: 2000
                    });
                    return;
                }
                const ids = this.selectData.map(it => it["id"]);
                this.pageLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                downloadByPost({
                    axios: this.$axios,
                    url: `/admin/order/${command}`,
                    data: ids,
                    success: response => {
                        convertRes2Blob(response);
                    },
                    faild: () => {
                        this.$message({
                            type: 'error',
                            message: '导出失败',
                            duration: 2000
                        });
                    },
                    complete: () => {
                        this.pageLoading.close();
                        this.pageLoading = undefined;
                    }
                });
            }
        },
    },
    mounted() {
        this.pageLoadng = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoadng.close();
            this.pageLoadng = undefined;
        }, 500);
        this.columnDrop();
    },
    activated() {
        // setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        // }, 500);
    },
    beforeDestroy() {
        if(this.pageLoadng) {
            this.pageLoadng.close();
            this.pageLoadng = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    },
    created() {
        this.onSearch();
        this.loadCompanys();
        this.loadSuppliers();
        window.addEventListener("resize", this.setTableHeight);
    },
}
</script>
<style>

    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
</style>